import cn from "classnames";
import React, { ReactNode } from "react";
import { FormattedMessage } from "react-intl";

type Scope = "company" | "personal";

interface Props {
  scope: Scope;
  descriptionId: string;
  children: ReactNode;
  connectedEmail?: string | null;
  connectedName?: string | null;
  connectedAvatar?: string | null;
}

export function IntegrationScopeBlock({
  scope,
  descriptionId,
  children,
  connectedEmail,
  connectedName,
  connectedAvatar,
}: Props) {
  const isConnected = Boolean(connectedEmail || connectedName);

  return (
    <div
      className={cn("integration-scope-block", {
        "integration-scope-block--connected": isConnected,
      })}
    >
      <div className="integration-scope-block__head">
        <span
          className={cn("integration-scope-block__badge", {
            "integration-scope-block__badge--company": scope === "company",
            "integration-scope-block__badge--personal": scope === "personal",
          })}
        >
          <FormattedMessage
            id={
              scope === "company"
                ? "app.integrations.scope.company"
                : "app.integrations.scope.personal"
            }
          />
        </span>
        <p className="integration-scope-block__desc mb-0">
          <FormattedMessage id={descriptionId} />
        </p>
      </div>

      {isConnected ? (
        <div className="integration-scope-block__account">
          {connectedAvatar ? (
            <img
              src={connectedAvatar}
              alt=""
              className="integration-scope-block__avatar"
              width={40}
              height={40}
            />
          ) : null}
          <div className="integration-scope-block__account-text">
            {connectedName ? (
              <div className="integration-scope-block__name">{connectedName}</div>
            ) : null}
            {connectedEmail ? (
              <div className="integration-scope-block__email">{connectedEmail}</div>
            ) : null}
          </div>
        </div>
      ) : null}

      <div className="integration-scope-block__action">{children}</div>
    </div>
  );
}
